<template>
  <div class="max-w-6xl mx-auto py-8">
    <FuelAnalytics />
  </div>
</template>

<script setup lang="ts">
import FuelAnalytics from '@/components/fuel/FuelAnalytics.vue';
</script>
